import Vue from 'vue'
import App from './App.vue'
import './plugins/iview.js'
import http from './traits/http'
import wechat from './traits/wechat'
import router from './router'
import store from './store'

Vue.mixin(http);
Vue.mixin(wechat);
Vue.config.productionTip = false

router.beforeEach((t, f, next) => {
    if ('title' in t.meta) {
        document.title = t.meta.title;
    }
    next();
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
